import { string } from 'yup';

import { NAME_REGEX } from '@air/utils-regex';

export const lastNameValidationSchema = string()
  .required('Last name is required')
  .matches(NAME_REGEX, 'No special characters allowed');
